<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title class="textwithbackground--text">
              {{ title }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <general-error v-if="!!generalError" />
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <v-row>
              <v-col>
                <v-expansion-panels>
                  <v-expansion-panel v-test="{ panel: '' }">
                    <v-expansion-panel-header>
                      <div id="search">
                        <v-icon>
                          search
                        </v-icon>
                        {{ $t('Фильтры') }}
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content eager @keydown.native.enter="focusOnBtn('searchBtn')">
                      <v-row class="px-3">
                        <v-col
                            class="pl-2"
                            cols="12"
                            md="5"
                            lg="4"
                            xl="3">
                          <validatable-text-input
                              v-model="params.pattern"
                              :label="$t('Содержание текста ошибки')"
                              hide-details
                              dense
                              @keydown.native.enter="focusOnBtn('searchBtn')" />
                        </v-col>
                        <v-col
                            class="px-6"
                            cols="12"
                            md="5"
                            lg="4"
                            xl="3">
                          <validatable-date-time-picker
                              v-model="params.fromDate"
                              :label="$t('Дата начала интервала')"
                              @keydown.native.enter="focusOnBtn('searchBtn')" />
                        </v-col>
                        <v-col
                            class="px-6"
                            cols="12"
                            md="5"
                            lg="4"
                            xl="3">
                          <validatable-date-time-picker
                              v-model="params.toDate"
                              :label="$t('Дата завершения интервала')"
                              @keydown.native.enter="focusOnBtn('searchBtn')" />
                        </v-col>
                        <v-col class="text-right" align-self="center">
                          <btn-icon-tip
                              id="search"
                              ref="searchBtn"
                              icon="search"
                              icon-color="primary"
                              :tip="$t('Поиск')"
                              @click="search" />
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <paginated-data-table
                    v-if="getLog"
                    ref="paginatedTable"
                    :headers="headers1"
                    :items="logs"
                    :loading="isLoading"
                    item-key="id"
                    :total-count="totalCount"
                    :items-per-page="itemsPerPage"
                    show-expand
                    :request-method="getLog">
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template v-slot:item.id="{ item }">
                    {{ item.id }}
                  </template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template v-slot:item.date="{ item }">
                    {{ item.date
                      ? $moment(item.date).format('DD.MM.YYYY HH:mm')
                      : null }}
                  </template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template v-slot:item.username="{ item }">
                    {{ item.username }}
                  </template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template v-slot:item.message="{ item }">
                    {{ item.message }}
                  </template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template v-slot:item.url="{ item }">
                    {{ item.url }}
                  </template>
                  <!-- eslint-disable-next-line vue/valid-v-slot -->
                  <template v-slot:item.requestId="{ item }">
                    {{ item.requestId }}
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <v-row class="text-left pa-2">
                        <v-col>
                          {{ item.exception }}
                        </v-col>
                      </v-row>
                    </td>
                  </template>
                </paginated-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
::v-deep td.otc-table-cell {
  /* padding-top: 10px; */
  vertical-align: top !important;
  background-color: rgb(240, 240, 240);
}
</style>

<script>
  import BtnIconTip from '../../../reused/ui/BtnIconTip.vue'
  import ValidatableTextInput from '../../../reused/ui/ValidatableTextInput.vue'
  import ValidatableDateTimePicker from '../../../reused/ui/ValidatableDateTimePicker.vue'
  import PaginatedDataTable from '../../../reused/ui/PaginatedDataTable.vue'
  import GeneralError from '../../../reused/common/GeneralError.vue'
  import { mapActions, mapState } from 'vuex'
  import { LOG_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      BtnIconTip,
      PaginatedDataTable,
      ValidatableTextInput,
      ValidatableDateTimePicker
    },
    data () {
      return {
        isLoading: false,
        itemsPerPage: 20,
        params: {
          pattern: null,
          fromDate: null,
          toDate: null
        }
      }
    },
    computed: {
      ...mapState(LOG_MANAGEMENT.NAMESPACE, {
        logsInfo: state => (state[LOG_MANAGEMENT.STATE.LOGS] || { })
      }),
      logs () {
        return this.logsInfo.items || []
      },
      totalCount () {
        return this.logsInfo.totalCount || 0
      },
      title () {
        return this.$t('Лог ошибок')
      },
      headers1 () {
        const headers =
          [
            { text: this.$t('Ид'), align: 'start', sortable: false, cellClass: 'otc-table-cell', value: 'id' },
            { text: this.$t('Дата'), align: 'start', sortable: false, cellClass: 'otc-table-cell', value: 'date' },
            { text: this.$t('Пользователь'), align: 'start', sortable: false, cellClass: 'otc-table-cell', value: 'username' },
            { text: this.$t('Сообщение'), align: 'start', sortable: false, cellClass: 'otc-table-cell', value: 'message' },
            // { text: this.$t('Ошибка'), align: 'start', sortable: false, cellClass: 'otc-table-cell', value: 'exception' },
            { text: this.$t('Url'), align: 'start', sortable: false, cellClass: 'otc-table-cell', value: 'url' },
            { text: this.$t('Идентификатор запроса'), align: 'start', sortable: false, cellClass: 'otc-table-cell', value: 'requestId' },
            { text: '', cellClass: 'otc-table-cell', value: 'data-table-expand' }
          ]
        return headers
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOG_MANAGEMENT.NAMESPACE, {
        clearAction: LOG_MANAGEMENT.ACTIONS.CLEAR,
        getLogAction: LOG_MANAGEMENT.ACTIONS.GET_LOG
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.clearAction()
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getLog: async function (params) {
        try {
          this.isLoading = true
          await this.getLogAction({
            params: {
              ...this.params,
              ...params
            }
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
